import type { Api, Vehicle } from '@cruz-com/lookup'
import { encodeQuery } from '@/lib'
import { baseURL, formatFetchError, getHeader } from '../util'

export async function searchPrivateVehicle(params: object): Promise<Api.Result<Vehicle.Summary[]>> {
  try {
    const res = await fetch(`${baseURL}/cruz/private-vehicles?${encodeQuery(params)}`, {
      method: 'GET',
      headers: await getHeader(),
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

export async function vehicleDetail(params: object): Promise<Api.Result<Vehicle.Detail>> {
  try {
    const res = await fetch(`${baseURL}/cruz/vehicle?${encodeQuery(params)}`, {
      method: 'GET',
      headers: await getHeader(),
      next: { revalidate: 5 },
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

export async function toggleDisableVehicle(id: string): Promise<Partial<Vehicle.Summary>> {
  try {
    const res = await fetch(`${baseURL}/cruz/vehicle/toggle-disable?id=${id}`, {
      method: 'PATCH',
      headers: await getHeader(),
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}
